import { FC, useEffect, useState } from 'react';

import { useSetRecoilState } from 'recoil';

import { GiftAgentOrderContext } from '@shared/utils/giftAgentOrder.util';

import { giftInputApplyRequestAtom } from '../state/giftInputApply.atom';
import { clearGiftItemOptionSelections } from '../utils/giftItemOptionStorage';

/**
 * 주문서 정리 버튼 — 주문서를 지금 응대 중인 상주 기준으로 되돌린다.
 * (다른 가족 주문 내용을 담아봤거나 앞선 응대 잔재가 남았을 때의 탈출구)
 *
 * 배치가 두 곳이라 공용 컴포넌트로 둔다.
 * - 데스크톱: "전화주문 진행 중" 배너 바로 아래 (상가 주문 내역과 구분)
 * - 모바일: 주문 내역 오버레이 안
 */
export const GiftAgentOrderResetButton: FC<{
  ctx: GiftAgentOrderContext;
  //* 실제로 정리했을 때만 호출 (오버레이 닫기 등)
  onReset?: () => void;
  className?: string;
}> = function GiftAgentOrderResetButton({ ctx, onReset, className }) {
  const [done, setDone] = useState(false);
  const setApplyRequest = useSetRecoilState(giftInputApplyRequestAtom);

  useEffect(() => {
    if (!done) return;
    const timer = setTimeout(() => setDone(false), 2000);
    return () => clearTimeout(timer);
  }, [done]);

  const handleClick = () => {
    const confirmed = window.confirm(
      `주문서를 ${ctx.memberName}님 기준으로 정리할까요?\n\n` +
        `· 감사글·보내는 이 → ${ctx.memberName}님 기본 내용\n` +
        `· 배송지 → 비움\n` +
        `· 상품 옵션 선택 → 비움`,
    );
    if (!confirmed) return;
    //* 지금 열려 있지 않은 상품의 옵션 선택(보존분)까지 함께 지운다
    clearGiftItemOptionSelections(ctx.bugoId);
    setApplyRequest({
      bugoId: ctx.bugoId,
      requestedAt: Date.now(),
      resetToMemberDefault: true,
    });
    setDone(true);
    onReset?.();
  };

  return (
    <button
      onClick={handleClick}
      className={`rounded-md border px-2 py-1.5 text-xs font-medium ${
        done
          ? 'border-green-300 bg-green-50 text-green-700'
          : 'border-gray-300 bg-white text-gray-600 hover:bg-gray-50'
      } ${className ?? ''}`}
    >
      {done ? '주문서를 정리했어요' : `주문서 정리 (${ctx.memberName}님 기본값으로)`}
    </button>
  );
};
